export default "__VITE_ASSET__CzurBkuL__"